<script>
import store from '@shared/store'
import axios from '@shared/module/axios'

export default {
  methods: {
    resetCache() {
      const pin = store.state.currentUser.pin
      const url = `/api/customers/${pin}/reset-cache`
      return axios.post(url)
          .catch(() => Promise.resolve())
    },
    resetCacheOverview() {
      const pin = store.state.currentUser.pin
      const url = `/api/customers/${pin}/reset-cache/overview`
      return axios.post(url)
          .catch(() => Promise.resolve())
    }
  }
}
</script>
